import orm from 'models'
import _ from 'lodash'
import { createSelector as ormSelector } from 'redux-orm'
import getEntities from 'selectors/entities'
import { getKeyWindowSelector } from 'selectors/key_windows'

const getAllContacts = ormSelector(orm, getEntities, (session) => {
  return _.sortBy(session.contact.all().toModelArray()
                .filter(contact => !contact.isArchived)
                .filter(contact => typeof contact.isPatient === 'boolean' && contact.isPatient === false)
                .map(contact => {
                  const {ref} = contact;
                  return {...ref}
                }), (contact) => `${contact.firstName} ${contact.lastName}`)
})

export const getContacts = (keyWindow) => getKeyWindowSelector('contact', keyWindow, getAllContacts)
